"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionSplitPackages = void 0;
const storageconstants_1 = require("./storageconstants");
const localforage_1 = __importDefault(require("localforage"));
const utils_1 = require("../utils/utils");
const safejson_1 = require("../utils/safejson");
const log = __importStar(require("../utils/log"));
const log_1 = require("../utils/log");
const ConnectionSplitSupportedVersionLimit = 2;
const ConnectionSplitSupportedSizeLimit = 63000;
// test
//  const ConnectionSplitSupportedSizeLimit = 500
const ConnectionReceiveKey = 'ConnectionReceiveKey';
const ConnectionSendKey = 'ConnectionSendKey';
const ConnectionTopicVersionKey = 'ConnectionSenderVersionKey';
class ConnectionSplitPackages {
    constructor(side) {
        // 发送队列, 保存分片数据，需要断点续传发送，
        this.splitMessageSendArray = new Map();
        // 接收队列, 保存回包数据，需要冗余去重复
        this.splitMessageReceivedArray = new Map();
        // sender 版本校验缓存
        this.splitMessageSenderVersionMap = new Map();
        this.splitPackageCache = localforage_1.default.createInstance({
            name: storageconstants_1.OKXCONNECTOR_STORAGE_PROTOCOL_CACHE + side
        });
    }
    init(sendRawMsg) {
        return __awaiter(this, void 0, void 0, function* () {
            // 1. 恢复缓存
            yield this.recoverFromCache();
            //2. 缓存中发送队列重发
            if (this.splitMessageSendArray.size > 0) {
                for (const [topic, payloadList] of this.splitMessageSendArray.entries()) {
                    for (let i = 0; i < payloadList.length;) {
                        const payload = payloadList[i];
                        try {
                            // 尝试发送消息
                            yield sendRawMsg((0, safejson_1.safeJsonStringify)(payload), topic);
                            log.logDebug(`Successfully sent payload: ${(0, safejson_1.safeJsonStringify)(payload)} to topic: ${topic}`);
                            // 成功后移除元素
                            payloadList.splice(i, 1);
                        }
                        catch (error) {
                            log.logError(`Failed to send payload: ${(0, safejson_1.safeJsonStringify)(payload)} to topic: ${topic}`, error);
                            // 重试逻辑（最多重试 3 次）
                            payload.retryCount = (payload.retryCount || 0) + 1;
                            if (payload.retryCount > 3) {
                                log.logError(`Payload failed after 3 retries: ${(0, safejson_1.safeJsonStringify)(payload)}`);
                                payloadList.splice(i, 1); // 放弃重试，移除元素
                            }
                            else {
                                i++; // 跳过当前元素，继续处理下一个
                            }
                        }
                    }
                }
                yield this.syncCache();
            }
        });
    }
    tryParseMessageSplitPayload(message) {
        var _a;
        let result = undefined;
        try {
            if (message.trimStart().startsWith('{')) {
                let messageObj = (0, safejson_1.safeJsonParse)(message);
                if (messageObj
                    && messageObj.protocol_version
                    && messageObj.protocol_version >= 2) {
                    let protocolMessageObject = messageObj;
                    if (protocolMessageObject.package_group_id && ((_a = protocolMessageObject.package_group_id) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        result = messageObj;
                    }
                }
            }
            else {
                (0, log_1.logDebug)('not split packages');
            }
        }
        catch (error) {
            (0, log_1.logDebug)('not split packages');
        }
        return result;
    }
    updateTopicSenderVersion(topic, protocolVersion) {
        return __awaiter(this, void 0, void 0, function* () {
            this.splitMessageSenderVersionMap.set(topic, protocolVersion);
            yield this.syncCache();
            (0, log_1.logDebug)('get update topic sender version: ', topic, protocolVersion);
        });
    }
    /**
     * topic
     * message 待发送的消息体
     * sendMsg 正常发送消息的方法
     * sendRawMsg 发送明文格式，即拆包消息的方法
    */
    sendSplitPackages(topic, message, sendMsg, sendRawMsg) {
        return __awaiter(this, void 0, void 0, function* () {
            // 1. 长度校验拆分子包
            // 2. 确认连接协议最大支持版本
            // 3. 分包缓存
            // 4. 缓存包发送
            // 5. ACK确认并清理缓存
            if (!topic) {
                log.logError('sendSplitPackages invalid topic');
                return;
            }
            let senderVersion = this.splitMessageSenderVersionMap.get(topic);
            let msgLength = message.length;
            try {
                if (msgLength < ConnectionSplitSupportedSizeLimit) {
                    throw new Error(`no need to split (size:${msgLength})`);
                }
                if (!senderVersion || (senderVersion && senderVersion < ConnectionSplitSupportedVersionLimit)) {
                    throw new Error(`version not support split (version: ${senderVersion})`);
                }
                const msg_parts = [];
                let msg_part_length = ConnectionSplitSupportedSizeLimit;
                for (let i = 0; i < message.length; i += msg_part_length) {
                    if (i + msg_part_length < message.length) {
                        msg_parts.push(message.slice(i, i + msg_part_length));
                    }
                    else {
                        msg_parts.push(message.slice(i));
                    }
                }
                let groupId = (0, utils_1.generateGroupId)();
                let splitMessagePackages = msg_parts.map((msg, index) => {
                    // make msg split parts
                    let msgObj = {
                        topicId: topic,
                        protocol_version: ConnectionSplitSupportedVersionLimit,
                        total_count: msg_parts.length,
                        package_index: index,
                        package_group_id: groupId,
                        content: msg
                    };
                    return msgObj;
                });
                // save cache
                this.mergePackageArray(true, splitMessagePackages);
                // try send out
                for (let i = 0; i < splitMessagePackages.length;) {
                    const msgObj = splitMessagePackages[i];
                    const payload = (0, safejson_1.safeJsonStringify)(msgObj);
                    try {
                        // 尝试发送消息
                        yield sendRawMsg(payload, topic);
                        log.logDebug(`Successfully sent payload: ${payload} to topic: ${topic}`);
                        // 成功后移除元素
                        splitMessagePackages.splice(i, 1);
                    }
                    catch (error) {
                        log.logError(`Failed to send payload: ${payload} to topic: ${topic}`, error);
                        // 重试逻辑（最多重试 3 次）
                        msgObj.retryCount = (msgObj.retryCount || 0) + 1;
                        if (msgObj.retryCount > 3) {
                            log.logError(`Payload failed after 3 retries: ${payload}`);
                            splitMessagePackages.splice(i, 1); // 放弃重试，移除元素
                        }
                        else {
                            i++; // 跳过当前元素，继续处理下一个
                        }
                    }
                }
                // clean cache
                this.splitMessageSendArray.set(topic, []);
                yield this.syncCache();
            }
            catch (e) {
                (0, log_1.logDebug)('send split packages no split');
                (0, log_1.logDebug)(e);
                yield sendMsg(topic, message);
            }
        });
    }
    onReceivedPackageCheck(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            // 1. merge 进入缓存
            this.mergePackageArray(false, [payload]);
            let completeMap = new Map();
            let inputTopic = payload.topicId;
            // 2. 返回检查结果,输出完整message结果
            this.splitMessageReceivedArray.forEach((itemList, topic) => {
                if (topic == payload.topicId) {
                    itemList.forEach((item) => {
                        if (item.messageObject.package_group_id) {
                            let messageCache = completeMap.get(item.messageObject.package_group_id);
                            if (!messageCache) {
                                messageCache = new Array();
                            }
                            messageCache.push(item);
                            completeMap.set(item.messageObject.package_group_id, messageCache);
                        }
                    });
                }
            });
            (0, log_1.logDebug)('on received message, check message cache');
            let checkResult = {
                isSplitPackage: false,
                // finalMessage: undefined,
                // completeMessageIdList: undefined 
            };
            if (payload.messageObject.package_group_id) {
                checkResult.isSplitPackage = true;
                let messageCache = completeMap.get(payload.messageObject.package_group_id);
                // 判断是否收齐
                if (messageCache === null || messageCache === void 0 ? void 0 : messageCache.length) {
                    let index_check = new Set();
                    messageCache.forEach((item) => {
                        if (item.messageObject.package_index !== undefined) {
                            index_check.add(item.messageObject.package_index);
                        }
                    });
                    if (index_check.size == payload.messageObject.total_count) {
                        // 满足条件，更新checkResult
                        messageCache.sort((a, b) => {
                            if ((a.messageObject.package_index || a.messageObject.package_index === 0)
                                && (b.messageObject.package_index || b.messageObject.package_index === 0)) {
                                return a.messageObject.package_index - b.messageObject.package_index;
                            }
                            else {
                                return 0;
                            }
                        });
                        let messageList = messageCache.reduce((msgList, item) => {
                            msgList.push(item.messageObject.content);
                            return msgList;
                        }, []);
                        let messageIdList = messageCache.reduce((msgIdList, item) => {
                            msgIdList.push(item.messageId);
                            return msgIdList;
                        }, []);
                        checkResult.isSplitPackage = true;
                        checkResult.finalMessage = messageList.join('');
                        checkResult.completeMessageIdList = messageIdList;
                        // 清理缓存
                        let receivedList = this.splitMessageReceivedArray.get(inputTopic);
                        if (receivedList) {
                            receivedList = receivedList.filter((item) => {
                                return !messageIdList.includes(item.messageId);
                            });
                            this.splitMessageReceivedArray.set(inputTopic, receivedList);
                        }
                        yield this.syncCache();
                    }
                }
            }
            // 抛出，交给manager来发送receive
            return checkResult;
        });
    }
    /* -------------------------- */
    /** private methods */
    /* -------------------------- */
    mergePackageArray(isSending, inputPayloadArray) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, log_1.logDebug)('append sending array');
            if (isSending) {
                let inputSendArray = inputPayloadArray;
                let filtedArray = inputSendArray.filter((payload) => {
                    let inputTopic = payload.topicId;
                    let accept = true;
                    let sendCacheArray = this.splitMessageSendArray.get(inputTopic);
                    sendCacheArray === null || sendCacheArray === void 0 ? void 0 : sendCacheArray.forEach((cachedPayload) => {
                        if (cachedPayload.package_group_id == payload.package_group_id
                            && cachedPayload.total_count == payload.total_count
                            && cachedPayload.package_index == payload.package_index) {
                            accept = false;
                        }
                    });
                    return accept;
                });
                if (filtedArray.length > 0) {
                    let inputTopic = filtedArray[0].topicId;
                    let sendArray = this.splitMessageSendArray.get(inputTopic);
                    if (!sendArray) {
                        sendArray = new Array();
                    }
                    sendArray = sendArray.concat(filtedArray);
                    this.splitMessageSendArray.set(inputTopic, sendArray);
                    (0, log_1.logDebug)('append sending array (after filted): ', sendArray);
                }
            }
            else {
                let inputReceiveArray = inputPayloadArray;
                let filtedArray = inputReceiveArray.filter((payload) => {
                    let inputTopic = payload.topicId;
                    let accept = true;
                    let receiveCacheArray = this.splitMessageReceivedArray.get(inputTopic);
                    receiveCacheArray === null || receiveCacheArray === void 0 ? void 0 : receiveCacheArray.forEach((cachedPayload) => {
                        if (cachedPayload.messageId == payload.messageId) {
                            accept = false;
                        }
                    });
                    return accept;
                });
                if (filtedArray.length > 0) {
                    let inputTopic = filtedArray[0].topicId;
                    let receiveArray = this.splitMessageReceivedArray.get(inputTopic);
                    if (!receiveArray) {
                        receiveArray = new Array();
                    }
                    receiveArray = receiveArray.concat(filtedArray);
                    this.splitMessageReceivedArray.set(inputTopic, receiveArray);
                    (0, log_1.logDebug)('append received array (after filted): ', receiveArray);
                }
            }
        });
    }
    syncCache() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, log_1.logDebug)('sync split message cache');
            yield this.splitPackageCache.setItem(ConnectionReceiveKey, this.splitMessageReceivedArray);
            yield this.splitPackageCache.setItem(ConnectionSendKey, this.splitMessageSendArray);
            yield this.splitPackageCache.setItem(ConnectionTopicVersionKey, this.splitMessageSenderVersionMap);
        });
    }
    recoverFromCache() {
        return __awaiter(this, void 0, void 0, function* () {
            // rec
            let rec_array = yield this.splitPackageCache.getItem(ConnectionReceiveKey);
            if (rec_array) {
                this.splitMessageReceivedArray = rec_array;
            }
            else {
                this.splitMessageReceivedArray = new Map();
            }
            //send
            let send_array = yield this.splitPackageCache.getItem(ConnectionSendKey);
            if (send_array) {
                this.splitMessageSendArray = send_array;
            }
            else {
                this.splitMessageSendArray = new Map();
            }
            // topic/version cach
            let topic = yield this.splitPackageCache.getItem(ConnectionTopicVersionKey);
            if (topic) {
                this.splitMessageSenderVersionMap = topic;
            }
            else {
                this.splitMessageSenderVersionMap = new Map();
            }
        });
    }
}
exports.ConnectionSplitPackages = ConnectionSplitPackages;
